@if (entry?.base?.display) {
  <div>
    <h3><strong>{{ entry.base?.text }}</strong></h3>
    @for (doc of doctors; track doc) {
      <div class='doc-container'>
        <span>{{doc.name}}</span>
        <small>{{doc.title}}</small>
        <small>{{doc.address}}</small>
      </div>
    }
    @if (!reviewOnly) {
      <button mat-raised-button class="edit-button" color="secondary" (click)="editQuestion()">Edit</button>
    }
  </div>
}